import React from 'react';
import { View } from "react-native"
import Colors from "../constants/Colorsv2"
import { Text, TouchableOpacity } from "../globalComponents/NativeOverrides"

type RadioButtonProps = {
    selected:boolean,
    title?:string,
    description?:string,
    onSelect:() => void
}

const RadioButton = ({ selected, title, description, onSelect }:RadioButtonProps) => {
    return (
        <TouchableOpacity style={{ flexDirection:'row', alignItems:'flex-start' }} onPress={() => onSelect()}>
            <View style={{ height:24, width:24, borderRadius:100, borderWidth:1, borderColor:Colors.highlights.highlight200, justifyContent:'center', alignItems:'center' }}>
                {selected?
                <View style={{ height:16, width:16, borderRadius:100, backgroundColor:Colors.highlights.highlight200 }} />
                :<></>}
            </View>
            {title && description ?
            <View style={{marginLeft:10}}>
                <Text size={14} color={Colors.brand.midnight} weight='bold'>{title}</Text>
                <Text size={14} color={Colors.brand.slate} weight='regular'>{description}</Text>
            </View>
            :<></>}
        </TouchableOpacity>
    )
}

export default RadioButton